<template>
  <div class="md:p-5 md:p-0 w-full">
    <div class="mx-4 p-4">
      <div class="flex items-center">
        <!-- Avatar - Create user -->
        <div class="flex items-center text-teal-600 relative">
          <div :class="avatarClasses(1)">
            <font-awesome-icon
              icon="user-plus"
              :style="iconColor(1)"
              size="lg"
            />
          </div>
          <div :class="textClasses(1)">
            {{ $t("signup.steps.createUser") }}
          </div>
        </div>

        <!-- Line - Create user -->
        <div :class="lineClasses(1)" />

        <!-- Avatar - Create Organization -->
        <div class="flex items-center text-white relative">
          <div :class="avatarClasses(2)">
            <font-awesome-icon
              icon="building"
              :style="iconColor(2)"
              size="lg"
            />
          </div>
          <div :class="textClasses(2)">
            {{ $t("signup.steps.createOrganization") }}
          </div>
        </div>

        <!-- Line - Create Organization -->
        <div :class="lineClasses(2)" />

        <!-- Avatar - First Integration -->
        <div class="flex items-center text-gray-500 relative">
          <div :class="avatarClasses(3)">
            <font-awesome-icon icon="cog" :style="iconColor(3)" size="lg" />
          </div>
          <div :class="textClasses(3)">
            {{ $t("signup.steps.firstIntegration") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // define props
  props: {
    currentStep: {
      type: Number,
      default: 1
    }
  },

  // computed property
  methods: {
    /**
     * Returns the avatar classes depends on the current step
     */
    avatarClasses(i) {
      // define base classes
      let baseClass = {
        flex: true,
        "justify-center": true,
        "rounded-full": true,
        transition: true,
        "duration-500": true,
        "ease-in-out": true,
        "h-12": true,
        "w-12": true,
        "py-3": true,
        "border-2": true
      }

      if (this.currentStep === i) {
        baseClass = {
          ...baseClass,
          "bg-r-primary": true,
          "border-r-primary": true
        }
      } else if (this.currentStep > i) {
        baseClass = {
          ...baseClass,
          "border-r-primary": true
        }
      } else {
        baseClass = {
          ...baseClass,
          "border-gray-300": true
        }
      }

      // return base classes
      return baseClass
    },

    /**
     * Returns the icon's color
     */
    iconColor(i) {
      if (this.currentStep === i) {
        return { color: "white" }
      } else if (this.currentStep > i) {
        return { color: "#2469EB" }
      } else {
        return { color: "#d1d5db" }
      }
    },

    /**
     * Returns the line classes
     */
    lineClasses(i) {
      let baseClass = {
        "flex-auto": true,
        "border-t-2": true,
        transition: true,
        "duration-500": true,
        "ease-in-out": true,
        "border-gray-300": true
      }

      if (this.currentStep > i) {
        baseClass = {
          ...baseClass,
          "border-r-primary": true
        }
      }

      return baseClass
    },

    /**
     * Returns the text classes
     */
    textClasses(i) {
      let baseClass = {
        absolute: true,
        "top-0": true,
        "-ml-10": true,
        "text-center": true,
        "mt-16": true,
        "w-32": true,
        "pl-5": true,
        "pr-5": true,
        "text-xs": true,
        "font-medium": true,
        uppercase: true,
        "text-gray-500": true,
        "md:visible": true,
        invisible: true
      }

      if (this.currentStep >= i) {
        baseClass = {
          ...baseClass,
          "text-r-primary": true
        }
      }

      return baseClass
    }
  }
}
</script>
